/**
 * CookieBanner - Banniere informative cookies (RGPD)
 * Affichee une seule fois, acceptation stockee en localStorage.
 */

import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, new Date().toISOString());
    setVisible(false);
  };

  // Jamais sur l'écran client (face client, non interactif — cursor-none)
  if (pathname === '/pos/affichage-client') return null;

  if (!visible) return null;

  return (
    // z-[60] : la barre de navigation du bas de la boutique est en z-50 et
    // arrive APRÈS dans le DOM — à égalité, c'est elle qui gagnait et le
    // bandeau devenait inatteignable (signalé le 04/09/2026). safe-area-bottom
    // pour que le bouton ne passe pas sous la barre d'accueil de l'iPhone.
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-white border-t border-gray-300 shadow-lg p-4 md:p-6 safe-area-bottom">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-4">
        <p className="text-sm text-gray-700 flex-1">
          Ce site utilise des cookies strictement necessaires a son fonctionnement (session, panier).
          Aucun cookie publicitaire ou de tracking n'est utilise.{' '}
          <Link to="/shop/cookies" className="text-green-700 hover:underline font-medium">
            En savoir plus
          </Link>
        </p>
        <button
          onClick={handleAccept}
          className="px-6 py-3 min-h-[44px] bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 active:bg-green-800 transition-colors whitespace-nowrap"
        >
          J'ai compris
        </button>
      </div>
    </div>
  );
}
